/** A submission ready for delivery: flat string fields, including `form_type` and `page_url`. */
export type FormPayload = Readonly<Partial<Record<string, string>>>;

export interface DeliveryRequest {
  readonly payload: FormPayload;
  /** Human-readable form name, e.g. "Enterprise demo request". */
  readonly formType: string;
  /** Email subject used by providers that send an email. */
  readonly subject: string;
  readonly replyTo: string;
}

/** Delivery failed; the visitor's entries are kept and they are offered the email fallback. */
export class FormDeliveryError extends Error {
  constructor(
    readonly provider: string,
    message: string,
  ) {
    super(`${provider}: ${message}`);
    this.name = 'FormDeliveryError';
  }
}
